export default "__VITE_ASSET__9e9b0fa8__"